export const MAIN_ROADMAP_NAME = 'Main Roadmap';
